var $3b62c0bcc6cf3c98$exports = {};
$3b62c0bcc6cf3c98$exports = {
    "pending": `v\xe4ntande`
};


export {$3b62c0bcc6cf3c98$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
